import React, {
  Dispatch, ReactElement, useRef,
} from 'react';
import {
  Button, Col, Row, Select,
} from 'idsk-react-components';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import {
  NavrhUzneseniaVladyCast,
} from '../../../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyCast';
import './castComponent.scss';
import BodComponent from './BodComponent';
import {
  NavrhUzneseniaVladyBod,
} from '../../../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyBod';
import { removeFieldAtIndex, updateFieldAtIndex } from '../../../../../function/updateArrayField';

export const dropdownValues = ['mení', 'dopĺňa', 'vymenúva', 'odvoláva', 'navrhuje zvoliť', 'schvaľuje',
  'poveruje', 'berie na vedomie', 'súhlasí', 'nesúhlasí', 'odporúča', 'ukladá', 'splnomocňuje',
  'určuje', 'zrušuje', '(iné)'];

export interface CastProps {
  castNazov: string;
  castData: NavrhUzneseniaVladyCast;
  setCastData: Dispatch<NavrhUzneseniaVladyCast>;
  onDeleteCast: () => void;
}

const CastComponent = ({
  castNazov, castData, setCastData, onDeleteCast,
}: CastProps): ReactElement => {
  const bodContainerRef = useRef<HTMLDivElement>(null);

  const updateBodList = (bodList: NavrhUzneseniaVladyBod[]): void => {
    setCastData({ ...castData, bodList });
  };
  const addBod = (): void => {
    updateBodList([...castData.bodList, {
      uuid: uuidv4(),
      zodpovednaOsoba: undefined,
      text: undefined,
      termin: undefined,
    }]);

    if (bodContainerRef.current?.lastElementChild) {
      setTimeout(() => {
        bodContainerRef.current.lastElementChild?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };
  return (
    <div className="cast-row-container">
      <Row>
        <Col>
          <div className="cast-container">
            <span className="cast-name-label">Časť {castNazov}</span>
            <Select
              id={castNazov}
              width="one-third"
              value={castData.zamerCasti}
              onChange={({ target }) => {
                setCastData({ ...castData, zamerCasti: target.value });
              }}
            >{dropdownValues.map(value => (
              <option
                key={value}
                value={value}
              >{value}
              </option>
            ))}
            </Select>
            <Button
              disabled={castData.bodList.length >= 99}
              className="cast-button"
              type="button"
              buttonStyle="third"
              size="large"
              onClick={addBod}
            >Pridať bod
            </Button>
            <ConfirmModal
              question="Naozaj si prajete odstrániť zvolenú časť?"
              description={'Po vykonaní tejto funkcionality budú odstránené '
                + 'aj všetky existujúce body pridané pod touto časťou.'}
              cancelButtonText="Nie"
              confirmButton={
                (
                  <Button
                    buttonStyle="negative"
                    size="large"
                  >
                    Áno
                  </Button>
                )
              }
              openButton={(
                <Button
                  className="cast-component-delete-button"
                  type="button"
                  buttonStyle="negative"
                  size="large"
                >Zmazať časť
                </Button>
              )}
              doAfterConfirm={onDeleteCast}
            />
          </div>
        </Col>
        <div className="bod-container" ref={bodContainerRef}>
          {castData.bodList.map((bod, index) => {
            const bodNumber = index + 1;
            return (
              <BodComponent
                key={bod.uuid}
                bodName={`Bod ${castNazov}.${bodNumber}`}
                bodData={bod}
                setBodData={(bodValue) => {
                  updateBodList(updateFieldAtIndex(castData.bodList, bodValue, index));
                }}
                onDeleteBod={() => {
                  updateBodList(removeFieldAtIndex(castData.bodList, index));
                }}
              />
            );
          })}
        </div>
      </Row>
    </div>
  );
};

export default CastComponent;
